import { useMemo } from 'react';
import MetricsTile, {
    MetricsTileComponent,
} from '../core/MetricsTile/MetricsTile';
import MetricsTable, {
    IMetricsTableRow,
} from '../core/MetricsTable/MetricsTable';
import { useTranslation } from 'react-i18next';
import { ReportingMetricsCounts } from '../../../../../../model/ReportingMetrics';

export interface IMetricsTableTileProps {
    previousItems: ReportingMetricsCounts;
    currentItems: ReportingMetricsCounts;
}

const RoutesTableTile: MetricsTileComponent<IMetricsTableTileProps> = ({
    title,
    previousItems,
    currentItems,
    className,
}) => {
    const { t } = useTranslation();

    const keyLabel = t('ReportingDashboard_Route');
    const valueLabel = t('ReportingDashboard_ConversationCount');

    const previousRows = useMemo<IMetricsTableRow[]>(() => {
        return Object.entries(previousItems)
            .map(([key, value]) => {
                return {
                    key,
                    value: value.value,
                };
            })
            .sort((a, b) => b.value - a.value);
    }, [previousItems]);

    const currentRows = useMemo<IMetricsTableRow[]>(() => {
        return Object.entries(currentItems)
            .map(([key, value]) => {
                return {
                    key,
                    value: value.value,
                    trend: value.trend,
                };
            })
            .sort((a, b) => b.value - a.value);
    }, [currentItems]);

    return (
        <MetricsTile
            title={title}
            previousRangeItem={
                !!previousRows.length ? (
                    <MetricsTable
                        rows={previousRows}
                        keyLabel={keyLabel}
                        valueLabel={valueLabel}
                        isPreviousRange
                    />
                ) : undefined
            }
            currentRangeItem={
                !!currentRows.length ? (
                    <MetricsTable
                        rows={currentRows}
                        keyLabel={keyLabel}
                        valueLabel={valueLabel}
                    />
                ) : undefined
            }
            className={className}
            vertical
            reversed
        />
    );
};

export default RoutesTableTile;
